import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FileSystemDirectoryEntry, FileSystemFileEntry, NgxFileDropEntry } from 'ngx-file-drop';

@Injectable({
  providedIn: 'root'
})



export class UploadDocumentosService {

  public files: NgxFileDropEntry[] = [];
  public documentos: any[] = []
  public documento: any;
  public headers: any
  public relativePath: any
  public e: any
  token: any
  url: any


  constructor(private http: HttpClient) { }

  

  public dropped(files: NgxFileDropEntry[]) {

    const uri = 'https://backend-xtensa-core.app.inpronet.es/upload';
    this.files = files;
    const formData = new FormData();
    for (const droppedFile of files) {
      
      if (droppedFile.fileEntry.isFile) {
        
          const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;
          
          fileEntry.file((file: File) => {
      
          
          formData.append('files', file);
            
       
          const headers = new HttpHeaders({
            'security-token': this.token,
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Methods': 'GET,POST,OPTIONS,DELETE,PUT'
          });
          
          
            
        });
        
      } else {
        
        const fileEntry = droppedFile.fileEntry as FileSystemDirectoryEntry;
        console.log(droppedFile.relativePath, fileEntry);
      }
    }
    return this.http.post(uri, formData)
  }


  setUrl(url:any){
    this.url = url; 
  }

  getUrl(){
    let temp = this.url;
    this.clearUrl();
    return temp;
  }

  clearUrl(){
    this.url = undefined;
  }

  setFiles(files:any){
    this.files = files; 
  }

  getFiles(){
    let temp = this.files;
    return temp;
  }

  
  
}
